import gsap, { Power4 } from "gsap";
import SplitType from "split-type";

class Title {
    constructor(el) {
        this.el = el;

        this.el && this.init();
    }

    init() {
        const tl = gsap.timeline({
            defaults: {
                duration: 0.6,
                ease: Power4.easeOut,
            },
        });
        const splitText = new SplitType(this.el, { types: ["words, chars"] });
        splitText.words.forEach(word => {
            word.setAttribute("aria-hidden", true);
        });

        tl.set(this.el, {
            autoAlpha: 1,
        });

        tl.from(splitText.chars, {
            y: "100%",
            autoAlpha: 0,
            stagger: 0.01,
        });
    }
}

const titleAnimations = () => {
    const titles = document.querySelectorAll(".title-animate");
    titles &&
        !window.matchMedia("(prefers-reduced-motion: reduce)").matches &&
        titles.forEach(title => new Title(title));
};

export default titleAnimations;
